import { useAllBanners } from '@entities/Banners'

import type { BlockProps } from '@features/main-page-builder/model/blockRegistry'
import styles from '@features/main-page-builder/ui/styles.module.scss'

import { BannerCarousel } from '@widgets/banner-carousel'
import BannerGrid from '@widgets/banner-grid/ui'


export default function BannerGalleryBlock ({ block, payload }: BlockProps) {
  const { banners, loading } = useAllBanners({
    typeId: payload?.id as string || ''
  })

  if (!payload?.id) {
    return null
  }

  const { subtype = 'small' } = block

  if (subtype === 'small') {
    // @ts-ignore
    return <BannerGrid banners={banners} loading={loading} />
  }

  return (
    <div className={styles.root__banner}>
      <BannerCarousel
        banners={banners}
        loading={loading}
        variant="simple"
      />
    </div>
  )
}
